import { useContext } from 'react';

import AuthContext from '../contexts/index';

const useAuth = () => useContext(AuthContext);

export default useAuth;
